/* eslint-disable warp-drive/no-legacy-request-patterns */
import Route from '@ember/routing/route';
import { service } from '@ember/service';
import { hash } from '@linc-technologies/linced-common/utils/promise';

export default class HeadingsRoute extends Route {
  // Services
  @service
  store;

  model(params) {
    let store = this.store;
    let group = store.findRecord('school-options/group', params.group_id);
    return hash({
      group,
      headings: store.query('school-options/heading', {
        optionGroupId: params.group_id,
      }),
    });
  }
}
